export interface IAuthor {
  uid: string;
  username: string;
  name: string;
  surname: string | null;
  isPremium?: boolean;
  image?: {
    url: string;
    mimeType?: string;
  } | null;
}
export const getPostsQuery = ({
  page,
  limit,
  text,
  author: authorUid,
  cashtag,
  hashtag,
  timeRange,
  who,
  order,
  subtype,
  topic,
  sortBy,
  hide = false,
}: GetPostsParams & { hide?: boolean }) => ({
  url: "/posts",
  params: {
    page,
    limit,
    text,
    author: authorUid,
    cashtag,
    hashtag,
    timeRange,
    who,
    order,
    subtype,
    topic,
    sortBy,
    hide,
  },
});

export interface IPostsResponse {
  data: IPost[];
  meta: {
    total: number;
    page: number;
    limit: number;
  };
}

export interface IPost {
  uid: string;
  content: string;
  published: boolean;
  postType: "FREE" | "PAID";
  price: number | null;
  createdAt: string;
  updatedAt: string;
  isLongForm: boolean;
  freeContentRange: number | null;
  topic: "STOCKS" | "ECONOMICS" | "PERSONAL";
  cashtags: string[];
  hashtags: string[];
  attachments: any;
  sources: string[];
  // subtype: "FUNDAMENTAL" | "TECHNICAL" | string;
  subtypes: any;
  author: IAuthor;
  comments: any[];
  likesCount: number;
  zapsCount: number;
  commentsCount: number;
  savesCount: number;
  isLiked: boolean;
  isSaved: boolean;
  isZapped: boolean;
  sentiment: number;
  likersPreview: string[];
  zappersPreview: string[];
  isPurchased: boolean;
  isArbitraryPrice: boolean;
  totalZapsAmount: number;
  html?: string | null;
  reactionsPreview: string[];
  totalLikesAmount: number;
}
export interface GetPostsParams {
  page?: number;
  limit?: number;
  text?: string;
  author?: string;
  topic?: string;
  cashtag?: string;
  hashtag?: string;
  timeRange?: string;
  who?: string;
  order?: "asc" | "desc";
  subtype?: string;
  sortBy?: string;
  hide?: boolean;
}

export interface IUserImage {
  url: string;
  mimeType: string;
}

export interface IReactionUser {
  uid: string;
  username: string;
  image?: IUserImage | null;
}

export interface ILikeItem {
  uid: string;
  createdAt: string;
  user: IReactionUser;
  amount: number;
}

export interface ILikeResponse {
  data: ILikeItem[];
  meta: {
    total: number;
    page: number;
    limit: number;
    pages: number;
    totalAmount: number;
    sortBy: "recent" | "amount";
    order: "asc" | "desc";
  };
}

export interface IZapItem {
  uid: string;
  createdAt: string;
  message?: string;
  amount: number;
  user: IReactionUser;
}

export interface IZapResponse {
  data: IZapItem[];
  meta: {
    total: number;
    page: number;
    limit: number;
    pages: number;
    totalAmount: number;
    sortBy: "recent" | "amount";
    order: "asc" | "desc";
  };
}
